module.exports = __webpack_public_path__ + "static/21-07-15_17-50-00_7490-2fed1e51adb971d031f4e84360b45ed9.jpg";